export const STATUS_MARCACAO = 1;
export const STATUS_EFETUADA = 2;
export const STATUS_REMARCADA = 3;
export const STATUS_NAO_COMPARECEU = 4;
export const STATUS_CANCELADA = 5;


// WEBPACK FOOTER //
// ./src/constants/visitaStatus.js